// BudgetAddItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class BudgetAddItem extends Component {
  static get propTypes () {
    return {
      filterType: PropTypes.string,
      onTimeActivityAdd: PropTypes.func,
      onExpenseActivityAdd: PropTypes.func,
      onTextAdd: PropTypes.func,
      onSubtotalAdd: PropTypes.func,
      onPhaseAdd: PropTypes.func,
      onIntroTextAdd: PropTypes.func,
      onClose: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      filterType: 'all',
      onTimeActivityAdd: null,
      onExpenseActivityAdd: null,
      onTextAdd: null,
      onSubtotalAdd: null,
      onPhaseAdd: null,
      onIntroTextAdd: null,
      onClose: null
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
  }

  componentDidMount () {
    window.rootApp.addEventListener('click', this._handleDocumentClick)
  }

  componentWillUnmount () {
    window.rootApp.removeEventListener('click', this._handleDocumentClick)
  }

  show () {
    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render () {
    const className = this.state.active
      ? 'purchaseorder-additem active'
      : 'purchaseorder-additem'

    return (
      <div className={className}>
        <div className='actionbtn'>
          <div className='actinfo'>
            <IntlMessage ident='project.viewBudget.titleBudgetIntroText' />
          </div>
          <IconButton
            type='primary'
            size='big'
            icon='purchaseorder-addexpense'
            className='purchaseadd'
            canHover={false}
            onClick={this._onItemClick.bind(this, 'introText')}
          />
        </div>
      </div>
    )
  }

  /* Event handlers */
  _handleDocumentClick = (_event) => {
    if (this.state.active) {
      this.hide()
    }
  };

  _onItemClick (type, ev) {
    if (this.props.onClose) {
      this.props.onClose()
    }

    if (type === 'phase' && this.props.onPhaseAdd) {
      this.props.onPhaseAdd(ev)
    } else if (type === 'introText' && this.props.onIntroTextAdd) {
      this.props.onIntroTextAdd(ev)
    } else if (type === 'timeActivity' && this.props.onTimeActivityAdd) {
      this.props.onTimeActivityAdd(ev)
    } else if (type === 'expenseActivity' && this.props.onExpenseActivityAdd) {
      this.props.onExpenseActivityAdd(ev)
    } else if (type === 'text' && this.props.onTextAdd) {
      this.props.onTextAdd(ev)
    }
  }
}

export default BudgetAddItem
